enum OrdersActionType {
    INITIALIZE_BILLING_ACCOUNTS_START = 'INITIALIZE_BILLING_ACCOUNTS_START',
    INITIALIZE_BILLING_ACCOUNTS_SUCCESS = 'INITIALIZE_BILLING_ACCOUNTS_SUCCESS',
    INITIALIZE_BILLING_ACCOUNTS_FAILURE = 'INITIALIZE_BILLING_ACCOUNTS_FAILURE',
    LOAD_BILLING_ACCOUNTS_SUCCESS = 'LOAD_BILLING_ACCOUNTS_SUCCESS',
    LOAD_BILLING_ACCOUNTS_START = 'LOAD_BILLING_ACCOUNTS_START',
    LOAD_BILLING_ACCOUNTS_FAILURE = 'LOAD_BILLING_ACCOUNTS_FAILURE',
    LOAD_CUSTOMER_INFORMATION_START = 'LOAD_CUSTOMER_INFORMATION_START',
    LOAD_CUSTOMER_INFORMATION_SUCCESS = 'LOAD_CUSTOMER_INFORMATION_SUCCESS',
    LOAD_CUSTOMER_INFORMATION_FAILURE = 'LOAD_CUSTOMER_INFORMATION_FAILURE',
    SET_SELECTED_BILLING_ACCOUNT_ID = 'SET_SELECTED_BILLING_ACCOUNT_ID',
    INITIALIZE_ORDERS_START = 'INITIALIZE_ORDERS_START',
    INITIALIZE_ORDERS_SUCCESS = 'INITIALIZE_ORDERS_SUCCESS',
    INITIALIZE_ORDERS_FAILURE = 'INITIALIZE_ORDERS_FAILURE',
    LOAD_INFLIGHT_ORDERS_START = 'LOAD_INFLIGHT_ORDERS_START',
    LOAD_INFLIGHT_ORDERS_SUCCESS = 'LOAD_INFLIGHT_ORDERS_SUCCESS',
    LOAD_INFLIGHT_ORDERS_FAILURE = 'LOAD_INFLIGHT_ORDERS_FAILURE',
    CREATE_ORDER_SUMMARY_START = 'CREATE_ORDER_SUMMARY_START',
    CREATE_ORDER_SUMMARY_SUCCESS = 'CREATE_ORDER_SUMMARY_SUCCESS',
    CREATE_ORDER_SUMMARY_FAILURE = 'CREATE_ORDER_SUMMARY_FAILURE',
    SET_SELECTED_ORDER_ID = 'SET_SELECTED_ORDER_ID',
    INITIALIZE_SCHEDULE_APPOINTMENT_START = 'INITIALIZE_SCHEDULE_APPOINTMENT_START',
    INITIALIZE_SCHEDULE_APPOINTMENT_SUCCESS = 'INITIALIZE_SCHEDULE_APPOINTMENT_SUCCESS',
    INITIALIZE_SCHEDULE_APPOINTMENT_FAILURE = 'INITIALIZE_SCHEDULE_APPOINTMENT_FAILURE',
    FETCH_AVAILABLE_TIME_START = 'FETCH_AVAILABLE_TIME_START',
    FETCH_AVAILABLE_TIME_SUCCESS = 'FETCH_AVAILABLE_TIME_SUCCESS',
    SUBMIT_SCHEDULE_APPOINTMENT_START = 'SUBMIT_SCHEDULE_APPOINTMENT_START',
    SUBMIT_SCHEDULE_APPOINTMENT_SUCCESS = 'SUBMIT_SCHEDULE_APPOINTMENT_SUCCESS',
    SUBMIT_SCHEDULE_APPOINTMENT_FAILURE = 'SUBMIT_SCHEDULE_APPOINTMENT_FAILURE',
    UPDATE_ACTIVATION_DATE_START = 'UPDATE_ACTIVATION_DATE_START',
    UPDATE_ACTIVATION_DATE_SUCCESS = 'UPDATE_ACTIVATION_DATE_SUCCESS',
    UPDATE_ACTIVATION_DATE_FAILURE = 'UPDATE_ACTIVATION_DATE_FAILURE',
    UPDATE_SHOPPING_CART_START = 'UPDATE_SHOPPING_CART_START',
    UPDATE_SHOPPING_CART_SUCCESS = 'UPDATE_SHOPPING_CART_SUCCESS',
    UPDATE_SHOPPING_CART_FAILURE = 'UPDATE_SHOPPING_CART_FAILURE',
    ORDER_RESET = 'ORDER_RESET',
}

export { OrdersActionType };
